const ARCHIVE_FOLDER = '/references-archives';

export function createFullUrlToArchive(archiveName) {
    // eslint-disable-next-line more/no-window
    const config = window.APP_CONF;

    return `${config.apiUrl}${ARCHIVE_FOLDER}/${archiveName}`;
}
